<template>
  <a :href="findEventLink()" class="event-card-link-wrapper">
    <article class="event-card-container">
      <div class="cover-image-container">
        <img v-if="event.cover" :src="event.cover" alt="event cover" class="cover-image">
        <a v-else :href="findEventInfoEditLink()" class="cover-placeholder">Add Cover</a>
      </div>
      <div class="event-data-container">
        <div class="event-date-location">
          {{ formatDate(event.from, event.to) }}
          <span v-if="event.location && event.location.city">
            &#8226; {{ event.location.city }}
          </span>
        </div>
        <div class="event-title">{{ event.title }}</div>
        <div v-if="event.extraModules && event.extraModules.ticketing" class="event-sales-info">
          <v-icon color="#979797">confirmation_number</v-icon>
          <span>{{ event.totalTicketsSold }}<span style="font-weight: 400">/{{ event.totalNumberOfTickets
          }}</span></span>
          <span style="margin: 0 0.25rem">&#8226;</span>
          <img src="/assets/money-bag.svg" alt="money bag">
          <span>{{ event.totalEarnings }} €</span>
        </div>
      </div>
    </article>
  </a>
</template>

<script>
import moment from 'moment'
import { OrganizationType } from '@/types'

export default {
  name: 'event-card',
  props: {
    event: Object,
    organizationType: String,
    organizationSlug: String,
  },
  methods: {
    formatDate(startDate, endDate) {
      let formattedDate = moment(startDate).format('DD.MM.YYYY.')

      const isEndDateOnSameDay = moment(endDate).isSame(moment(startDate), 'day')

      if (!isEndDateOnSameDay) {
        formattedDate += ` - ${moment(endDate).format('DD.MM.YYYY.')}`
      }

      return formattedDate
    },
    findEventLink() {
      if (this.organizationType === OrganizationType.THEATER) {
        return `/theater-organizations/${this.organizationSlug}/event/${this.event.id}${this.event.durationInMins ? '/accreditations' : ''}`
      }

      const prefix = this.organizationType === OrganizationType.SPORT_ORGANIZATION ? 'sport-' : ''

      return `/${prefix}organizations/${this.organizationSlug}/events/${this.event.id}${this.event.extraModules.ticketing ? '' : '/accreditations'}`
    },
    findEventInfoEditLink() {
      if (this.organizationType === OrganizationType.THEATER) {
        return `/theater-organizations/${this.organizationSlug}/event/${this.event.id}/info#event-cover-field`
      }

      const prefix = this.organizationType === OrganizationType.SPORT_ORGANIZATION ? 'sport-' : ''

      return `/${prefix}organizations/${this.organizationSlug}/events/${this.event.id}/info#event-cover-field`
    },
  },
}
</script>

<style scoped>
.event-card-container {
  display: flex;
  padding: 1rem 0;
  gap: 1rem;
  flex-wrap: wrap;
}

.cover-image-container {
  padding: 0 1rem;
  height: 4.31rem;
}

.cover-image {
  height: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 0.25rem;
}

.cover-placeholder {
  height: 100%;
  padding: 0 1.25rem 0 1.3125rem;
  aspect-ratio: 16 / 9;
  display: flex;
  justify-content: center;
  align-items: center;

  color: #0277BD;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Raleway;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.015rem;

  border-radius: 0.25rem;
  border: 2px dashed #CEE4F2;
}

.cover-placeholder:hover {
  border: 2px dashed #56A4EF;
  background: #F0F6FA;
}

.cover-placeholder:active {
  border: 2px dashed #0277BD;
  background: #E6F1F8;
}

.event-data-container {
  margin: 0 1.5rem 0 1rem;
  flex: 1;
}

.event-date-location {
  color: #666;
  font-family: "Source Sans Pro";
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 0.5rem;
}

.event-title {
  color: #666;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.045rem;
}

.event-sales-info {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  white-space: nowrap;

  color: #979797;
  font-family: "Source Sans Pro";
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}

.event-card-link-wrapper {
  border-radius: 0.5rem;
  border: 1px solid #D9D9D9;
}

.event-card-link-wrapper:hover {
  border-color: #979797;
  box-shadow: 0 4px 16px 0 rgba(51, 51, 51, 0.16);
}

.event-card-link-wrapper:active {
  border-color: #979797;
  box-shadow: 0 4px 40px 0 rgba(51, 51, 51, 0.32);
}

.event-card-link-wrapper:focus-visible {
  outline: none;
  border-color: #D9D9D9;
  box-shadow: 0 0 0 4px #CEE4F2;
}

@media screen and (max-width: 500px) {
  .event-card-link-wrapper {
    margin: 0 -1.5rem;
    border-radius: 0;
    border-left: unset;
    border-right: unset;
  }

  .event-card-link-wrapper:not(:last-child) {
    border-bottom: unset;
  }
}
</style>
